import SelectBuscable, { type OpcionDeSelect } from "@/shared/components/SelectBuscable";

export type FilterOption = OpcionDeSelect;

/**
 * Selector de filtro de la app, en el estilo de listado: botón blanco con borde
 * y chevron, el mismo de los filtros de almacén.
 *
 * Ahora es una capa fina sobre `SelectBuscable`: conserva sus propiedades para
 * no tocar las pantallas que ya lo usan, y gana lo que trae el componente
 * nuevo —se puede escribir para filtrar las opciones—. Soporta grupos para los
 * casos donde el `select` original usaba `optgroup`.
 */
export default function FilterSelect({
  label,
  options,
  value,
  onChange,
  allLabel = "Todos",
  ancho = "completo",
  className = "",
}: {
  label: string;
  options: FilterOption[];
  value: string;
  onChange: (v: string) => void;
  /** Texto de la opción que limpia el filtro; `null` si el filtro ya trae la suya. */
  allLabel?: string | null;
  /**
   * `completo` ocupa todo el ancho disponible; `contenido` se ajusta al texto.
   *
   * Los filtros de Almacén usan `contenido` porque van en una fila donde cada
   * uno mide lo suyo; los de proveedores y RH usan `completo` porque van en una
   * rejilla de columnas iguales.
   */
  ancho?: "completo" | "contenido";
  className?: string;
}) {
  return (
    <SelectBuscable
      variante="listado"
      etiqueta={label}
      todos={allLabel ?? undefined}
      canDelete={allLabel !== null}
      opciones={options}
      value={value}
      onChange={onChange}
      ancho={ancho}
      className={className}
      aria-label={label}
    />
  );
}
